var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"graph",attrs:{"height":"300px","width":"1000px"}},[_c('p',[_vm._v("graph")])])}
var staticRenderFns = []

export { render, staticRenderFns }